export default "__VITE_ASSET__d5dcc401__"